import React from 'react'
import { useHistory } from 'react-router'
import { DocumentText } from 'iconsax-react'
import { useTheme } from '@mui/material'
import { useAppDispatch, useAppSelector } from '@SonarCX/hooks/redux'

import { Routes } from '@SonarCX/Routes'
import { ReminderItemProps } from '..'
import { fetchArticle, selectArticles } from '@SonarCX/slices/article'
import Tooltip from '@SonarCX/components/atoms/Tooltip'

import useStyles from '../styles'

const ReminderArticle: React.FC<ReminderItemProps> = ({ object_id }) => {
  const theme = useTheme()
  const classes = useStyles()
  const history = useHistory()
  const dispatch = useAppDispatch()
  const { articles } = useAppSelector(selectArticles)
  const fullArticle = React.useMemo(
    () => articles[object_id] ?? null,
    [articles, object_id]
  )
  const navigate = () => {
    history.push(`${Routes.DOCUMENTS}/${object_id}`)
  }
  // Gets the full article
  React.useEffect(() => {
    if (fullArticle) {
      return
    }
    dispatch(fetchArticle(object_id))
  }, [object_id, fullArticle, dispatch])

  if (!fullArticle) return null

  return (
    <div className={classes.root} onClick={navigate}>
      <span className={classes.info}>
        <Tooltip title='Article'>
          <DocumentText
            size={theme.size.base}
            variant='Bulk'
            color={theme.palette.primary.main}
          />
        </Tooltip>
        <span className={classes.title}> {fullArticle.title}</span>
      </span>
    </div>
  )
}

export default ReminderArticle
